<template>
  <div class="interiorzone">
    <div class="toptitbox">
      <h2 class="subheading">网商承兑行更新</h2>
      <!-- <div class="btnbox">
        <button @click="obtainrate()">点此更新利率</button>
        <button @click="openbank()">点此更新银行</button>
      </div> -->
    </div>
    <div class="contentbox">
      <div class="content-order-listbox">
        <ul class="content-organ-list">
          <li class="hd">
            <span>序号</span>
            <span>银行名称（网名）</span>
            <span>银行名称（官方）</span>
            <span>检索关键字</span>
            <span>检索标识</span>
            <span>操作</span>
          </li>
          <li  v-for="(item,index) in companylist" v-bind:key="index">
            <span>{{index + 1}}</span>
            <span>{{item.bankName}}</span>
            <span><input type="text" v-model="item.bankNameView"></span>
            <span><input type="text" v-model="item.keyWord"></span>
            <span><input type="text" v-model="item.keyTag"></span>
            <span class="infoperation"><div class="btnblue" @click="bankupdate(index)">更新</div></span>
          </li>
        </ul>
        <ul class="listpage" v-if="ifpageshow">
          <li @click="loadata(1)">首页</li> <!--这里是1-->
          <li v-for="(item,index) in pagenum" v-bind:key="index" :class="currentPage==item?'active':''"  @click="nextpage(item)">{{item}}</li>
          <li @click="loadata(total)">尾页</li><!--这里是pagenum-->
        </ul>
      </div>
    </div>

    <div class="rejectbox" v-if="isinter">
      <h1>请粘贴需要解析的贴现利率及贴现行：</h1>
      <textarea v-model="ratecode"></textarea>
      <div class="btn-confirm"><button class="addok"  @click="obtainrate()">提交解析</button> <button class="addno" @click="colosepanel(1)">取消</button></div>
    </div>

    <div class="rejectbox" v-if="isbank">
      <h1>请粘贴需要解析的银行信息：</h1>
      <textarea v-model="bankcode"></textarea>
      <div class="btn-confirm"><button class="addok"  @click="obtainbank()">提交解析</button> <button class="addno" @click="colosepanel(1)">取消</button></div>
    </div>


  </div>
</template>
<script>
export default {
  data() {
    return {
      pagenum:0,
      currentPage:1,
      pageSize:10,
      officialname:'',
      companylist:[],
      keyword:'',
      tagtxt:'',
      isinter:'',
      isbank:'',
      ifpageshow:false,
      analysisdata:'',
      recordname:'',
      ratecode:'',
      bankcode:''
    }
  },
  mounted:function() {
    this.readlist()
  },
  methods: {
    readlist(){
     this.ajax.post('/auth/newdiscountbank',{bizContent:{}})
      .then(
        result=>{
          if(result.data.status=='0000'){
            this.pagenum=result.data.data.pages
            this.pagenum>1?this.ifpageshow=true:this.ifpageshow=false
            this.companylist=result.data.data
          }
        }
      )
    },
    openinter(){
      this.isinter=true
    },
    colosepanel(){
      this.isinter=false
      this.isbank=false
    },
    bankupdate(val){
      this.ajax.post('/auth/updatediscountbank',{bizContent:{bankId:this.companylist[val].bankId,bankNameView:this.companylist[val].bankNameView,keyWord:this.companylist[val].keyWord,keyTag:this.companylist[val].keyTag}})
      .then(
        result=>{
          if(result.data.status=='0000'){
            swal({
              text: '更新成功！~',
              buttons: false,
              icon:'success',
              timer: 2000,
            })
            this.readlist()
          }
          else{
            swal({
              text: result.data.message,
              buttons: false,
              timer: 2000
            })
          }
        }
      )
    },
    obtainrate(){
      this.ajax.post('/auth/updateAllRate',{bizContent:{dataList:this.ratecode}})
      .then(
        result=>{
          if(result.data.status=='0000'){
            swal({
              text: '解析成功！~',
              buttons: false,
              icon:'success',
              timer: 2000,
            })
            this.colosepanel()
          }
        }
      )
    },
    obtainbank(){
      this.ajax.post('/auth/addInite',{bizContent:{stringParam:this.bankcode}})
      .then(
        result=>{
          if(result.data.status=='0000'){
            swal({
              text: '解析成功！~',
              buttons: false,
              icon:'success',
              timer: 2000,
            })
            this.readlist()
            this.colosepanel()
          }
        }
      )
    },
    openbank(){
      this.isbank=true
    }
  }
}
</script>

<style scoped>
.content-order-listbox{
min-height: 500px;
}
.infoperation i:last-child{
margin-left: 15px;
}
.rejectbox{
  position: absolute;
  left: 50%;
  top:50%;
  margin-left:-322px;
  margin-top:-167px;
  width:645px;
  height:334px;
  background:rgba(255,255,255,1);
  box-shadow:0px 2px 10px rgba(204,204,204,1);
  border-radius:2px;
}
.rejectbox h2,.rejectbox textarea{
  width:581px;
  margin:0 auto;
  display: block;
  margin-top:10px;
}
.rejectbox h1{
  font-size: 18px;
  text-align: center;
  margin-top:16px;
}
.rejectbox .h2{
  font-size: 14px;
  color:#222222;
}
.rejectbox .hd2{
  font-size: 16px;
  color:#222222;
  margin-top:32px;
}
.rejectbox textarea{
  margin-top:20px;
   width:561px;
  padding:5px 10px;
  height:130px;
  border:1px solid rgba(227,228,229,1);
  margin-bottom: 10px;
}
.rejectbox .btn-confirm button{
  width:240px;
  height:52px;
  line-height:52px;
  border-radius: 2px;
  cursor: pointer;
}
.rejectbox .addno{
  border:1px solid rgba(61,143,226,1);
  box-shadow:0px 2px 7px rgba(61,143,226,0.5);
  margin-left:20px;
}
.rejectbox ul{
  width:92%;
  height:auto;
  display: table;
  background:rgba(255,255,255,1);
  border:1px solid rgba(227,228,229,1);
  margin:10px auto;
}
.rejectbox ul li{
  width:100%;
  height:40px;
  line-height:40px;
  clear: both;
}
.rejectbox ul li span{
  width:45%;
  display: block;
  float: left;
  height:40px;
  line-height:40px;
  text-align: center;
  font-size: 12px;
}
.rejectbox ul li span i{
  max-width: 170px;
  overflow: hidden;
  position: relative;
}
.rejectbox ul li span i:nth-child(2){
  margin:0 10px;
}
.rejectbox ul li span:nth-child(2){
  width:45%;
}
.rejectbox ul li span:first-child{
  width:10%;
}
.rejectbox ul li:nth-child(odd){
  background-color: #f3f3f3;
  
}
.rejectbox ul li:first-child span{
  font-size: 14px;
}
.tpadd{
  position: absolute;
  left: 50%;
  top:50%;
  margin-left:-322px;
  margin-top:-167px;
  width:645px;
  min-height:334px;
  display: table;
  padding-top:10px;
  background:rgba(255,255,255,1);
  box-shadow:0px 2px 10px rgba(204,204,204,1);
  border-radius:2px;
  padding-bottom: 30px;
}
.redio:hover{
  text-decoration: underline;
  color:rgba(61,143,226,1);
}

.content-organ-list li span{width:17%;}
.content-organ-list li span:nth-child(2){width:16.6%;}
.content-organ-list li span:nth-child(5){width:14.6%;}
.content-organ-list li span:nth-child(7){width:18.6%;}
.content-organ-list li span input{
  width:80%;
  text-indent: 10px;
  height:26px;
  background:rgba(238,238,238,1);
  box-shadow:0px 2px 7px rgba(61,143,226,0.5);
  margin:0 auto;
}
.toptitbox{
  clear: both;
  height:45px;
  line-height:45px;
  display: block;
}
.toptitbox .subheading,.toptitbox .btnbox{
  float: left;
  display: table;
}
.toptitbox .btnbox{
  margin-left:45px;
}
.toptitbox .btnbox button{
  width:111px;
  height:39px;
  line-height: 39px;
  text-align: center;
  background:rgba(61,143,226,1);
  box-shadow:0px 2px 7px rgba(61,143,226,0.5);
  border-radius:2px;
  color: #fff;
  cursor: pointer;
}
.toptitbox .btnbox button:last-child{
 margin-left: 22px;
}
.btnblue{
  width:80px;
  text-align: center;
  height:32px;
  line-height: 32px;
  color:#fff;
  border-radius: 2px;
  background: rgba(61,143,226,1);
  margin:0 auto;
  cursor: pointer;
  margin-top:4px;
}
</style>


// WEBPACK FOOTER //
// src/page/bankacceptance/interestrate.vue